import * as React from 'react';
import { PrivacyPolicy } from './PrivacyPolicy';

export class PonderaFooter extends React.Component {
    public render() {
        return (
            <div className="pondera-footer">
                <p className="text-muted small">The Pondera® Virtual Advisor is intended for use by the organization as a supplement to other evaluation criteria available, including prior knowledge and performance of the individual.  It is not intended as the sole basis for evaluation.</p>
                <p className="text-muted small">The goal of the Pondera® Virtual Advisor is to allow the user to obtain information as to a particular individual's preferences or preferred operating style.  When this information is combined with the organization's knowledge of and experience with the individual, it can assist the organization in effectively utilizing the skills, abilities, and strengths of each person to increase both organizational and individual efficiency and effectiveness.</p>
                <p className="text-muted small">© Pondera Technologies LLC {(new Date()).getFullYear()}</p>
                <div className="text-muted small"><PrivacyPolicy /></div>
            </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/PonderaFooter.tsx